import React, {Component} from 'react';
import {FormattedMessage} from 'react-intl';
import './SloganSection.css';

class ContactUsSection extends Component {
    render() {
        return (
            <div className="container">
                <div className="row d-flex justify-content-center">
                    <div className="menu-content pb-30 col-lg-8">
                        <div className="title text-center">
                            <h1 className="mb-10"><FormattedMessage id='contact_us_sec_title'
                                                                    description='say hello to Howard.'
                                                                    defaultMessage='{contact_us_sec_title_str}'
                                                                    values={{contact_us_sec_title_str: this.props.contact_us_sec_title,}}
                            ></FormattedMessage></h1>
                            <FormattedMessage id='contact_us_sec_summary'
                                              tagName={"p"}
                                              description='say hello to Howard.'
                                              defaultMessage='{contact_us_sec_summary_str}'
                                              values={{contact_us_sec_summary_str: this.props.contact_us_sec_summary,}}
                            ></FormattedMessage>
                        </div>
                    </div>
                </div>
                <form className="form-area mt-60 contact-form text-right" id="myForm" method="post">
                    <div className="row">
                        <div className="col-lg-6 form-group">
                            <input name="name" placeholder="Enter your name (稱呼)"
                                   className="common-input mb-20 form-control"
                                   required="" type="text"></input>

                            <input name="email" placeholder="Enter email address (電郵)"
                                   pattern="[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{1,63}$"
                                   className="common-input mb-20 form-control"
                                   required="" type="email"></input>

                            <input name="subject" placeholder="Enter your subject (標題)"
                                   className="common-input mb-20 form-control"
                                   required="" type="text"></input>
                        </div>
                        <div className="col-lg-6 form-group">
                        <textarea className="common-textarea mt-10 form-control" name="message" placeholder="Messege (信息)"
                                  required=""></textarea>
                            <button className="primary-btn mt-20">Send (提交)<span
                                className="lnr lnr-arrow-right"></span></button>
                            <div className="mt-10 alert-msg">
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        );
    }
}

export default ContactUsSection;


// WEBPACK FOOTER //
// ./src/components/ContactUsSection.js